import React from 'react'
import { Box, Typography } from '@mui/material'

interface GreenBoxProps {
  title?: string;
  children: React.ReactNode;
}

const GreenBox: React.FC<GreenBoxProps> = ({ title, children }) => (
  <Box sx={{
    bgcolor: '#01A32D0D',
    borderRadius: '8px',
    display: 'flex',
    padding: '24px',
    alignItems: 'flex-start',
    gap: '8px',
  }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'baseline' }}>
      <Typography sx={{ color: 'success.main' }}>
        <strong>{title}</strong>
      </Typography>
      {children}
    </Box>
  </Box>
)

export default GreenBox
